import { FieldType } from '../../views/Sources/Mapping/types';

export const isDateFilterField = (fieldName: string | null | undefined, fieldMap: Record<string, { type?: unknown }>): boolean =>
  !!fieldName && [FieldType.Date, FieldType.DateTime].includes(fieldMap[fieldName]?.type as string);
